import React from 'react';

import { useCurrentOrgName } from '@hcs/auth';
import { TopLevelBanner } from '@hcs/design-system';
import { PageTitle } from '@hcs/design-system';
import { OrgReportPreferences } from '@hcs/report-api';

const dataHcName = 'org-report-preferences-page';
export const OrgReportPreferencesPage = () => {
  const { data: orgName } = useCurrentOrgName();
  return (
    <>
      <PageTitle dataHcName={`${dataHcName}-title`}>
        {orgName || 'Organization'} Report Preferences
      </PageTitle>
      <TopLevelBanner dataHcName={`${dataHcName}-warning`}>
        Changing these settings affects all users in your organization.
      </TopLevelBanner>
      <OrgReportPreferences />
    </>
  );
};
